'use client';

import { initPostHog } from '@/lib/posthog';
import NextError from 'next/error';
import { useEffect } from 'react';

export default function GlobalError({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useEffect(() => {
    // Initialize PostHog and capture the exception
    const posthog = initPostHog();

    // Capture the exception with additional context
    posthog.captureException(error, {
      digest: error.digest,
      source: 'global-error-boundary',
      url: typeof window !== 'undefined' ? window.location.href : 'unknown',
    });

    // Log to console in development
    console.error('Global error:', error);
  }, [error]);

  return (
    <html>
      <body>
        <div style={{ padding: '2rem', textAlign: 'center' }}>
          <h2>Something went wrong!</h2>
          <p>We&apos;ve been notified and are looking into it.</p>
          <button
            onClick={reset}
            style={{
              marginTop: '1rem',
              padding: '0.5rem 1rem',
              background: '#0070f3',
              color: 'white',
              border: 'none',
              borderRadius: '4px',
              cursor: 'pointer',
            }}
          >
            Try again
          </button>
        </div>
        {/* Fallback to NextError for additional error info in development */}
        {process.env.NODE_ENV === 'development' && <NextError statusCode={0} />}
      </body>
    </html>
  );
}
